import { useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

/**
 * Ejecuta un request Hooli (que devuelve el sobre { status, result }) y
 * maneja el caso de error: con showSnackbar=true (default) lo muestra en el
 * snackbar global y devuelve undefined; con showSnackbar=false relanza el
 * error para que lo maneje el caller.
 */
export function useMIAService(callback, showSnackbar = true) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    return useCallback(async (body) => {
        try {
            const response = await callback(body, credentials);
            if ( showSnackbar ){
                if ( 
                    response?.status?.action === "E" &&
                    (response?.status?.errcode || response?.status?.errmsg)
                ) {
                    setSnackbarInfo({
                        message: response.status.errmsg,
                        severity: "error",
                        open: true,
                    });
                }
                return response?.result ?? [];
            }
            return response
        } catch (e) {
            if (!showSnackbar) throw e;

            setSnackbarInfo({
                message: e.message ?? e.errmsg,
                severity: "error",
                open: true,
            });
        }
    }, [callback, credentials, setSnackbarInfo, showSnackbar]);
}
